import { ReactComponent as NoAdvisoriesIcon } from 'assets/icons/noAdvisories.svg';
import { Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const styles = {
	main: {
		margin: '50px 0px',
		width: '100%',
		textAlign: 'center'
	},
	lineOne: {
		fontWeight: 700,
		fontSize: '2rem'
	},
	lineTwo: {
		lineHeight: 1,
		padding: '1rem 1.5rem 0px'
	}
};

const NoAdvisories = () => {
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	return (
		<div className={classes.main}>
			<div>
				<NoAdvisoriesIcon />
			</div>
			<>
				<Typography variant='h4' className={classes.lineOne}>
					Let&apos;s Fly!
				</Typography>
				<Typography variant='h6' color='textSecondary' className={classes.lineTwo}>
					There are no advisories in the area. It&apos;s safe to fly.
				</Typography>
				<Typography color='textSecondary'>
					<strong>Note:</strong> Be aware of live flights around you
				</Typography>
			</>
		</div>
	);
};

export default NoAdvisories;
